import type { Car } from '@/entities/cars/car.entity.ts';
import type { VehicleType } from '@/entities/vehicle-type.entity.ts';

export const carProp = <
  T extends keyof Pick<
    Car,
    | 'imageUrl'
    | 'fuelType'
    | 'transmission'
    | 'drive'
    | 'batteryCapacityInKwh'
    | 'tankVolumeInLiter'
    | 'rangeInKm'
    | 'seats'
    | 'additionalSeats'
    | 'power'
    | 'accelaration'
    | 'hasNavigation'
    | 'hasDistanceControl'
    | 'hasRearViewCamera'
  >,
>(
  car: Car,
  prop: T,
): (Car | VehicleType)[T] => {
  return car[prop] ?? car.vehicleType[prop];
};
